import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MainLayout } from './components/layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  PlansPage,
  TemplateSelectionPage,
  PlanWizardPage,
  PlanEditorPage,
} from './pages';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          
          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PlansPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/plans"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PlansPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/plans/new"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <TemplateSelectionPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/plans/new/wizard/:templateId"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PlanWizardPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/plans/:planId"
            element={
              <ProtectedRoute>
                <PlanEditorPage />
              </ProtectedRoute>
            }
          />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
